import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Bio from "@/components/Bio";
import Journey from "@/components/Journey";
import GalleryRow from "@/components/GalleryRow";
import Numbers from "@/components/Numbers";
import Speaking from "@/components/Speaking";
import Media from "@/components/Media";
import MediaIndex from "@/components/MediaIndex";
import PhotoBand from "@/components/PhotoBand";
import Books from "@/components/Books";
import Television from "@/components/Television";
import WorldOfSusan from "@/components/WorldOfSusan";
import Podcast from "@/components/Podcast";
import InfiniteApp from "@/components/InfiniteApp";
import Testimonials from "@/components/Testimonials";
import CoverStar from "@/components/CoverStar";
import SocialStar from "@/components/SocialStar";
import Watch from "@/components/Watch";
import ProducerPitch from "@/components/ProducerPitch";
import PressContact from "@/components/PressContact";
import ClosingCTA from "@/components/ClosingCTA";
import Footer from "@/components/Footer";

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" />
      <div className="noise-overlay" aria-hidden="true" />
      <AnimatePresence mode="wait">{loading && <Preloader key="preloader" />}</AnimatePresence>
      {!loading && (
        <main data-testid="main-site">
          <Navbar />
          <Hero />
          <Marquee />
          <Numbers />
          <Bio />
          <Journey />
          <GalleryRow />
          <Speaking />
          <Media />
          <MediaIndex />
          <PhotoBand />
          <Books />
          <Television />
          <WorldOfSusan />
          <Podcast />
          <InfiniteApp />
          <Testimonials />
          <CoverStar />
          <SocialStar />
          <Watch />
          <ProducerPitch />
          <PressContact />
          <ClosingCTA />
          <Footer />
        </main>
      )}
    </div>
  );
}
